import { Link, Navigate, useParams } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import AuthAwareLink from '../components/AuthAwareLink';
import Seo from '../seo/Seo';
import { ROOM_TYPE_PAGES } from '../seo/landingData';
import { buildBreadcrumbSchema } from '../seo/structuredData';
import CollapsibleSeoContent from '../components/seo/CollapsibleSeoContent';
import { getSeoContent, getSeoFaqSchema } from '../seo/seoContentData';

function RoomTypePage() {
  const { roomType } = useParams();
  const details = ROOM_TYPE_PAGES[roomType || ''];

  if (!details) {
    return <Navigate to="/" replace />;
  }

  const path = `/room-types/${roomType}`;
  const breadcrumb = buildBreadcrumbSchema([
    { name: 'Home', path: '/' },
    { name: 'Room Types', path: '/ai-tools/ai-room-decoration' },
    { name: details.roomType, path },
  ]);

  return (
    <div className="page landing-bg">
      <Seo
        title={details.title}
        description={details.description}
        canonicalPath={path}
        keywords={details.keywords}
        structuredData={[breadcrumb, getSeoFaqSchema(path)].filter(Boolean)}
      />
      <Navbar />
      <main className="container section">
        <h1>{details.h1}</h1>
        <p>{details.description}</p>

        <h2>Best Use Cases</h2>
        <p>
          Generate multiple visual directions before investing in furniture, wall paint, flooring, and decoration for
          your {details.roomType.toLowerCase()}. Use AI previews to compare looks side by side and eliminate
          guesswork before committing to any purchase.
        </p>

        <h2>Popular Styles for Your {details.roomType}</h2>
        <ul>
          {details.styles.map((style) => (
            <li key={style}><strong>{style}</strong></li>
          ))}
        </ul>

        <h2>Tips for a Better AI Result</h2>
        <ul>
          <li>Take the photo from a corner or doorway to capture as much of the room as possible.</li>
          <li>Use natural daylight or even lighting — avoid harsh shadows across walls or floors.</li>
          <li>Generate several variations of the same style before moving on to compare options.</li>
        </ul>

        <h2>Recommended Workflow</h2>
        <p>
          Upload a clear photo, choose your preferred style, and compare several generations side by side. Once you
          find a direction you like, use the result as a reference when shopping for furniture or speaking with a
          contractor.
        </p>

        <Link to="/register" className="btn btn-primary">
          Start Your {details.roomType} Redesign
        </Link>

        <div className="rt-related-links" style={{ marginTop: '2rem' }}>
          {details.gallerySlug && (
            <a href={`/gallery/${details.gallerySlug}/`} className="btn btn-ghost">
              {details.roomType} Gallery
            </a>
          )}
          <Link to="/real-transformations" className="btn btn-ghost">Real Transformations</Link>
          <AuthAwareLink spaPath="/faq" staticPath="/faq/" className="btn btn-ghost">FAQ</AuthAwareLink>
        </div>
      </main>

      <CollapsibleSeoContent {...getSeoContent(path)} />

      <Footer />
    </div>
  );
}

export default RoomTypePage;
